import axios from 'axios';
import React, { useEffect, useState } from 'react';
import baseURL from '../../config';
import { useParams } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Paper,
  Typography,
  Container,
} from '@mui/material';
import bgImage from "../../assets/shipimage.jpg";

const ExecutiveList = () => {
  const [executives, setExecutives] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const fetchExecutiveDetails = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${baseURL}/api/executiveDetails/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        setExecutives(response.data.data);
      } catch (err) {
        console.error("Error fetching executive details:", err);
      }
    };
    fetchExecutiveDetails();
  }, [id]);

  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.4)), url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        // alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={12}
          sx={{
            borderRadius: 4,
            overflow: 'hidden',
            p: 4,
            backgroundColor: 'rgba(255,255,255,0.95)',
            boxShadow: 6,
          }}
        >
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ fontWeight: 'bold', color: 'red' }}
          >
            Executive List
          </Typography>

          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: 'red' }}>
                <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Email</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Phone Number</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {executives.map((executive, index) => (
                <TableRow key={executive._id || index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{executive.name}</TableCell>
                  <TableCell>{executive.email}</TableCell>
                  <TableCell>{executive.phoneNumber}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Container>
    </Box>
  );
};

export default ExecutiveList;
